export default "__VITE_ASSET__DbaPNDgL__"